import {createActionCreators, ImmerReducer} from 'immer-reducer'
import defaultDatabasesState, {DatabaseNodeType, DatabasesStateType} from './state'
import {Status, UrlSelection} from 'commonTypes'
import {ConfigurationOptionType, ConfigurationOptionValueInput, DatabaseEnableUpdateInput, DatabaseMetadata, FeatureFlagStatus, FeatureFlagUpdateInput, BulkEditConfigurationInput, JobTypeOption, DeleteCustomConfigOverrideTagInput} from 'graphql-api'
import {
  getActiveDatabaseUrls,
  getConfigurationOptions,
  getCustomConfigOverrides,
  getDatabaseDetails,
  getDatabases,
  getJobTypeOptions,
} from 'api/graphQL/queries/databases.queries'
import {FiltersType} from './state'
import {
  select_bulkEdit,
  select_gridSession} from './selectors'
import {normalizeForApi} from 'helpers/databases'
import {customMessageRequest, genericRequestError, genericRequestSuccess} from 'redux/toast/toast.duck'
import apiRoutes from 'api/routes/paths'
import {StatusCode} from 'status-code-enum'
import {getFeatureFlags} from 'api/graphQL/queries/databases.queries'
import {bulkEditConfiguration, databaseEnableUpdate, featureFlagUpdate, deleteCustomConfigOverrideTag} from 'api/graphQL/mutations/databases.mutations'
import {v4 as uuid} from 'uuid'
import {resetLoading} from 'react-redux-loading-bar'
import {validateUrls} from 'helpers/common'
import {DatabasesGridSessionAC} from './gridSession.duck'
const CONFIG_OPTION_DATABASE_ENABLED = 'DatabaseEnabled'

class Databases extends ImmerReducer<DatabasesStateType> {
  showDatabaseDetails() {
    this.draftState.showDetails = true
  }
  hideDatabaseDetails() {
    this.draftState.showDetails = false
  }
  toggleDatabaseDetails() {
    this.draftState.showDetails = !this.state.showDetails
  }
  databaseIdCopiedTimerApplied(timer: ReturnType<typeof setTimeout>) {
    this.draftState.databaseIdCopyTimer = timer
  }
  databaseIdToCopyApplied(databaseId: string) {
    this.draftState.databaseIdToCopy = databaseId
  }
  fetchDatabasesGO() {
    this.draftState.status = Status.PENDING
  }
  fetchDatabasesOK(databases: DatabaseMetadata[]) {
    this.draftState.databases = databases
    this.draftState.status = Status.OK
  }
  fetchDatabasesERR(error) {
    this.draftState.error = error
    this.draftState.status = Status.REJECTED
  }
  fetchDatabaseDetailsGO() {
    this.draftState.statusDetails = Status.PENDING
  }
  fetchDatabaseDetailsOK(database: DatabaseNodeType) {
    this.draftState.error = defaultDatabasesState.error
    this.draftState.database = database
    this.draftState.statusDetails = Status.OK
  }
  fetchDatabaseDetailsERR(error) {
    this.draftState.database= defaultDatabasesState.database
    this.draftState.error = error
    this.draftState.statusDetails = Status.REJECTED
  }

  syncDbOK(){
    this.draftState.status = Status.OK
  }
  syncDbGO(){
    this.draftState.status = Status.PENDING
  }
  syncDbERR(error){
    this.draftState.error = error
    this.draftState.status = Status.REJECTED
  }

  toggleDatabaseEnabledGO() {
    this.draftState.status = Status.PENDING
  }
  toggleDatabaseEnabledOK(rowIndex:number) {
    this.draftState.databases[rowIndex].enabled = !this.draftState.databases[rowIndex].enabled
    this.draftState.status = Status.OK
  }
  toggleDatabaseEnabledERR(error) {
    this.draftState.error = error
    this.draftState.status = Status.REJECTED
  }
  fetchFeatureFlagsGO(requestId) {
    this.draftState.currentLegionFeatureFlags.status = Status.PENDING
    this.draftState.currentLegionFeatureFlags.error = null
    this.draftState.currentLegionFeatureFlags.requestId = requestId
    this.draftState.currentLegionFeatureFlags.flags = {}
  }
  fetchFeatureFlagsOK(featureFlags, requestId) {
    if (this.draftState.currentLegionFeatureFlags.requestId == requestId) {
      this.draftState.currentLegionFeatureFlags.status = Status.OK
      this.draftState.currentLegionFeatureFlags.error = null
      this.draftState.currentLegionFeatureFlags.requestId = requestId
      this.draftState.currentLegionFeatureFlags.flags = {...featureFlags}
    }
  }
  fetchFeatureFlagsERR(err, requestId) {
    if (this.draftState.currentLegionFeatureFlags.requestId == requestId) {
      this.draftState.currentLegionFeatureFlags.status = Status.REJECTED
      this.draftState.currentLegionFeatureFlags.error = err
      this.draftState.currentLegionFeatureFlags.requestId = requestId
      this.draftState.currentLegionFeatureFlags.flags = {}
    }
  }
  legionFeatureFlagToggleGO() {
    this.draftState.currentLegionFeatureFlags.error = null
  }
  legionFeatureFlagToggleOK(featureFlagStatus) {
    this.draftState.currentLegionFeatureFlags.flags[featureFlagStatus.name] = featureFlagStatus.status
    this.draftState.currentLegionFeatureFlags.status = Status.OK
  }
  legionFeatureFlagToggleERR(err) {
    this.draftState.currentLegionFeatureFlags.status = Status.REJECTED
    this.draftState.currentLegionFeatureFlags.error = err
  }

  fetchJobTypeOptionsGO(requestId) {
    this.draftState.jobTypeOptions.status = Status.PENDING
    this.draftState.jobTypeOptions.error = null
    this.draftState.jobTypeOptions.requestId = requestId
    this.draftState.jobTypeOptions.options = []
  }

  fetchJobTypeOptionsOK(options, requestId) {
    if (this.draftState.jobTypeOptions.requestId == requestId) {
      this.draftState.jobTypeOptions.status = Status.OK
      this.draftState.jobTypeOptions.error = null
      this.draftState.jobTypeOptions.requestId = requestId
      this.draftState.jobTypeOptions.options = options
    }
  }

  fetchJobTypeOptionsERR(err, requestId) {
    this.draftState.jobTypeOptions.status = Status.REJECTED
    this.draftState.jobTypeOptions.error = err
    this.draftState.jobTypeOptions.requestId = requestId
    this.draftState.jobTypeOptions.options = []
  }

  fetchCustomConfigOverridesGO(requestId) {
    this.draftState.currentLegionCustomConfigOverrides.status = Status.PENDING
    this.draftState.currentLegionCustomConfigOverrides.error = null
    this.draftState.currentLegionCustomConfigOverrides.requestId = requestId
    this.draftState.currentLegionCustomConfigOverrides.overridesByJobType = []
  }
  fetchCustomConfigOverridesOK(customConfigOverrides, requestId) {
    if (this.draftState.currentLegionCustomConfigOverrides.requestId == requestId) {
      this.draftState.currentLegionCustomConfigOverrides.status = Status.OK
      this.draftState.currentLegionCustomConfigOverrides.error = null
      this.draftState.currentLegionCustomConfigOverrides.requestId = requestId
      this.draftState.currentLegionCustomConfigOverrides.overridesByJobType = customConfigOverrides
    }
  }
  fetchCustomConfigOverridesERR(err, requestId) {
    if (this.draftState.currentLegionCustomConfigOverrides.requestId == requestId) {
      this.draftState.currentLegionCustomConfigOverrides.status = Status.REJECTED
      this.draftState.currentLegionCustomConfigOverrides.error = err
      this.draftState.currentLegionCustomConfigOverrides.requestId = requestId
      this.draftState.currentLegionCustomConfigOverrides.overridesByJobType = []
    }
  }

  deleteCustomConfigOverridesOK(jobType, id) {
    const updated = this.draftState.currentLegionCustomConfigOverrides.overridesByJobType.map(current => {
      if (current.jobType === jobType) {
        return {
          ...current,
          overrides: current.overrides.filter(y => y.name !== id),
        }
      }
      return current
    })

    this.draftState.currentLegionCustomConfigOverrides.overridesByJobType = updated
  }

  fetchConfigurationOptionsGO(requestId) {
    this.draftState.configurationOptions.status = Status.PENDING
    this.draftState.configurationOptions.error = null
    this.draftState.configurationOptions.requestId = requestId
    this.draftState.configurationOptions.options = []
  }

  fetchConfigurationOptionsOK(configurationOptions, requestId) {
    if (this.draftState.configurationOptions.requestId == requestId) {
      this.draftState.configurationOptions.status = Status.OK
      this.draftState.configurationOptions.error = null
      this.draftState.configurationOptions.requestId = requestId
      this.draftState.configurationOptions.options = configurationOptions
    }
  }

  fetchConfigurationOptionsERR(err, requestId) {
    if (this.draftState.configurationOptions.requestId == requestId) {
      this.draftState.configurationOptions.status = Status.REJECTED
      this.draftState.configurationOptions.error = err
      this.draftState.configurationOptions.requestId = requestId
      this.draftState.configurationOptions.options = []
    }
  }

  showBulkEditPanel() {
    this.draftState.showBulkEditPanel = true
  }
  hideBulkEditPanel() {
    this.draftState.showBulkEditPanel = false
  }
  submitBulkEditRequestGO() {
    this.draftState.status = Status.PENDING
  }
  submitBulkEditRequestOK() {
    this.draftState.status = Status.OK
  }
  submitBulkEditRequestERR() {
    this.draftState.status = Status.REJECTED
  }
  specifyUrlsApplied(specifiedUrls) {
    this.draftState.specifiedUrls = specifiedUrls
  }
  urlSelectionApplied(option) {
    if(option) {
      this.draftState.urlOption = option
    } else {
      this.draftState.urlOption = defaultDatabasesState.urlOption
    }
  }
  configurationOptionSelectionApplied(option) {
    if(option) {
      this.draftState.configurationOption = option
    } else {
      this.draftState.configurationOption = defaultDatabasesState.configurationOption
    }
    this.draftState.configurationValue = defaultDatabasesState.configurationValue
  }

  configurationValueApplied(value)  {
    this.draftState.configurationValue = value
  }

  configurationEnabledApplied(enabled)  {
    this.draftState.configurationEnabled = enabled
  }

  clearBulkEditForm() {
    this.draftState.configurationOption = defaultDatabasesState.configurationOption
    this.draftState.urlOption = defaultDatabasesState.urlOption
    this.draftState.specifiedUrls = defaultDatabasesState.specifiedUrls
    this.draftState.configurationValue = defaultDatabasesState.configurationValue
    this.draftState.configurationEnabled = defaultDatabasesState.configurationEnabled
  }
}

export const fetchDatabases = () => async function(dispatch, getState) {
  const gridSession = select_gridSession(getState())
  const {filters} = normalizeForApi(gridSession)

  dispatch(databasesAC.fetchDatabasesGO())
  try {
    const {data} = await getDatabases(filters)

    if (data.databases && data.databases.length) {
      dispatch(databasesAC.fetchDatabasesOK(data.databases))
    } else if (data.databases && !data.databases.length){
      dispatch(databasesAC.fetchDatabasesOK([]))
      dispatch(customMessageRequest('information', 'No databases found'))
    }
  } catch (err) {
    dispatch(genericRequestError())
    dispatch(databasesAC.fetchDatabasesERR(JSON.parse(JSON.stringify(err))))
  }
}

export const refreshDatabases = (
  routerInstance,
  filters?: FiltersType
) => async function(dispatch, getState) {
  const gridSession = select_gridSession(getState())

  const {
    globals: {params: stateParams, current: {name: stateName}},
    stateService,
  } = routerInstance

  dispatch(databasesAC.hideDatabaseDetails())
  dispatch(databasesAC.databaseIdToCopyApplied(''))

  if(filters){
    dispatch(DatabasesGridSessionAC.filtersApplied(filters))
  }

  await stateService.go(stateName, {
    ...stateParams,
    filters: filters ?? gridSession.filters,
  })
}

export const fetchDatabaseDetails = (databaseId: string) => async function(dispatch) {
  dispatch(databasesAC.fetchDatabaseDetailsGO())
  try {
    const {data} = await getDatabaseDetails(databaseId)

    let database: DatabaseNodeType = null
    if (data.databases && data.databases.length) {
      database = data.databases[0]
      dispatch(databasesAC.fetchDatabaseDetailsOK(database))
    } else if (data.databases && !data.databases.length) {
      throw new Error()
    }
  } catch (err) {
    dispatch(genericRequestError())
    dispatch(databasesAC.fetchDatabaseDetailsERR(JSON.parse(JSON.stringify(err))))
  }
}

export const legionFeatureFlagToggle = (databaseId: string, featureFlagStatus: FeatureFlagStatus) => async function (dispatch) {
  dispatch(databasesAC.legionFeatureFlagToggleGO())
  try {

    const input: FeatureFlagUpdateInput = {
      databaseId: databaseId,
      name: featureFlagStatus.name,
      status: featureFlagStatus.status,
    }
    const {data} = await featureFlagUpdate(input)
    if (data.featureFlagUpdate.database) {
      dispatch(databasesAC.legionFeatureFlagToggleOK(featureFlagStatus))
      dispatch(genericRequestSuccess())
    }
  } catch(err) {
    dispatch(genericRequestError())
    dispatch(databasesAC.legionFeatureFlagToggleERR(JSON.parse(JSON.stringify(err))))
  }
}

export const syncDb = (routerInstance) => async function(dispatch) {
  dispatch(databasesAC.syncDbGO())
  try {
    const response = await fetch(apiRoutes.databaseSync)
    if (response.status === StatusCode.SuccessOK) {
      dispatch(databasesAC.syncDbOK())
      dispatch(genericRequestSuccess())
      await routerInstance.stateService.reload()
    } else {
      throw {message: 'Server Error', status: response.status}
    }
  } catch (err) {
    dispatch(genericRequestError())
    dispatch(databasesAC.syncDbERR(JSON.parse(JSON.stringify(err))))
  }
}

export const toggleDatabaseEnabled = (routerInstance, rowIdx, databaseId: string, enabled: boolean) => async function (dispatch) {
  dispatch(databasesAC.toggleDatabaseEnabledGO())
  try {
    const input: DatabaseEnableUpdateInput = {
      databaseId,
      enabled,
    }
    const {data, errors} = await databaseEnableUpdate(input)
    if (data.databaseEnableUpdate?.database) {
      dispatch(genericRequestSuccess())
      dispatch(databasesAC.toggleDatabaseEnabledOK(rowIdx))
    } else {
      throw {message: 'Something went wrong when toggling enable database', status: StatusCode.SuccessAccepted}
    }
    if (errors?.length) {
      throw errors
    }
  } catch (err) {
    dispatch(databasesAC.toggleDatabaseEnabledERR(JSON.parse(JSON.stringify(err))))
    dispatch(genericRequestError())
  }
}

export const fetchJobTypeOptions = () => async function(dispatch) {
  const requestId = uuid()
  dispatch(resetLoading())
  dispatch(databasesAC.fetchJobTypeOptionsGO(requestId))
  try {
    const {data} = await getJobTypeOptions()
    if(data?.jobTypeOptions){
      dispatch(databasesAC.fetchJobTypeOptionsOK(data?.jobTypeOptions, requestId))
    }
  } catch (err) {
    dispatch(databasesAC.fetchJobTypeOptionsERR(err, requestId))
  }
}

export const fetchFeatureFlags = (databaseId: string) => {
  return async function (dispatch) {
    const requestId = uuid()
    dispatch(resetLoading())
    dispatch(databasesAC.fetchFeatureFlagsGO(requestId))
    try {
      const {data: {featureFlags}} = await getFeatureFlags(databaseId)
      const listFeatureFlags = {}
      featureFlags.forEach((item) => {
        listFeatureFlags[item.name] = item.status
      })
      dispatch(databasesAC.fetchFeatureFlagsOK(listFeatureFlags, requestId))
    } catch (err) {
      dispatch(databasesAC.fetchFeatureFlagsERR(err, requestId))
    }
  }
}

export const fetchConfigurationOptions = () => async function(dispatch) {
  const requestId = uuid()
  dispatch(resetLoading())
  dispatch(databasesAC.fetchConfigurationOptionsGO(requestId))
  try {
    const {data: {configurationOptions}} = await getConfigurationOptions()
    dispatch(databasesAC.fetchConfigurationOptionsOK(configurationOptions, requestId))
  } catch (err) {
    dispatch(databasesAC.fetchConfigurationOptionsERR(err, requestId))
  }
}

export const fetchCustomConfigOverrides = (databaseId: string, jobTypeOptions: JobTypeOption[]) => async function (dispatch) {
  const requestId = uuid()
  dispatch(resetLoading())
  dispatch(databasesAC.fetchCustomConfigOverridesGO(requestId))

  try {
    const [customConfigOverridesData, configurationOptionsData] = await Promise.all([
      fetchCustomConfigData(databaseId, jobTypeOptions),
      getConfigurationOptions(),
    ])

    const customConfigOverridesArr = customConfigOverridesData.data.customConfigOverrides
    const configurationOptions = configurationOptionsData.data.configurationOptions

    const result = [
      ...processJobTypeOverrides(jobTypeOptions, customConfigOverridesArr),
      ...processOrphanedOverrides(jobTypeOptions, customConfigOverridesArr, configurationOptions),
    ]

    dispatch(databasesAC.fetchCustomConfigOverridesOK(result, requestId))
  } catch (err) {
    dispatch(databasesAC.fetchCustomConfigOverridesERR(err, requestId))
  }
}

const fetchCustomConfigData = async (databaseId: string, jobTypeOptions: JobTypeOption[]) => {
  const allOverrideKeys = jobTypeOptions.flatMap(option => option.overrides)
  return await getCustomConfigOverrides(databaseId, allOverrideKeys)
}

const processJobTypeOverrides = (jobTypeOptions: JobTypeOption[], customConfigOverrides: any[]) => {
  return jobTypeOptions
    .map(({jobType, overrides}) => {
      const matchedOverrides = filterValidOverrides(customConfigOverrides, overrides)
      return matchedOverrides.length > 0 ? {jobType, overrides: matchedOverrides} : null
    })
    .filter(Boolean)
}

const processOrphanedOverrides = (jobTypeOptions: JobTypeOption[], customConfigOverrides: any[], configurationOptions: any[]) => {
  const allJobTypeOverrideKeys = jobTypeOptions.flatMap(option =>
    option.overrides.map(override => override?.toLowerCase())
  )

  const orphanedOverrides = customConfigOverrides.filter(override =>
    hasValidValue(override) && !isMatchedToJobType(override, allJobTypeOverrideKeys)
  )

  return groupOrphanedOverridesByConfigGroup(orphanedOverrides, configurationOptions)
}

const filterValidOverrides = (customConfigOverrides: any[], overrideKeys: string[]) => {
  return customConfigOverrides.filter(override =>
    hasValidValue(override) &&
    overrideKeys.some(key => key?.toLowerCase() === override.name?.toLowerCase())
  )
}

const hasValidValue = (override: any) => override?.value !== ''

const isMatchedToJobType = (override: any, allJobTypeOverrideKeys: string[]) => {
  return allJobTypeOverrideKeys.includes(override.name?.toLowerCase())
}

const groupOrphanedOverridesByConfigGroup = (orphanedOverrides: any[], configurationOptions: any[]) => {
  const groupedByConfigName = new Map<string, any[]>()

  orphanedOverrides.forEach(override => {
    const matchingConfigOption = configurationOptions.find(option =>
      option.tag?.toLowerCase() === override.name?.toLowerCase()
    )

    if (matchingConfigOption) {
      const groupName = matchingConfigOption.groupName || 'Other'
      if (!groupedByConfigName.has(groupName)) {
        groupedByConfigName.set(groupName, [])
      }
      groupedByConfigName.get(groupName)!.push(override)
    }
  })

  return Array.from(groupedByConfigName.entries()).map(([groupName, overrides]) => ({
    jobType: groupName,
    overrides,
  }))
}

export const submitBulkEditRequest = (router) => async function (dispatch, getState) {
  dispatch(databasesAC.submitBulkEditRequestGO())
  try {
    const {
      configurationOption,
      urlOption,
      configurationValue,
      configurationEnabled,
      specifiedUrls,
    } = select_bulkEdit(getState())

    const {data} = await getActiveDatabaseUrls()
    let databases = data.databases
    let databaseIds: string[] = []

    if (configurationOption?.value !== CONFIG_OPTION_DATABASE_ENABLED) {
      databases = databases.filter(x => x.enabled ?? true)
    }
    if(urlOption?.value === UrlSelection.ALL) {
      databaseIds = databases.map(x => x.databaseId)
    } else if (urlOption?.value === UrlSelection.MULTIPLE) {
      const {invalidUrls, validDatabaseIds} = validateUrls(databases, specifiedUrls)
      if (invalidUrls.length) {
        const errorMessage = `${invalidUrls.length} invalid url(s) provided. Top 10=\n${invalidUrls.slice(0, 10).join('\n')}`
        dispatch(customMessageRequest('critical', errorMessage))
        dispatch(databasesAC.submitBulkEditRequestERR())
        return false
      }
      databaseIds.push(...validDatabaseIds)
    }

    if (configurationOption != undefined) {
      const configuration: ConfigurationOptionValueInput = {
        tag: configurationOption?.value,
        value: configurationOption?.type !== ConfigurationOptionType.Boolean ? configurationValue : configurationEnabled.toString(),
      }

      const input: BulkEditConfigurationInput = {
        databaseIds: databaseIds,
        configuration: configuration,
      }
      const {data} = await bulkEditConfiguration(input)
      if (data.bulkEditConfiguration.requests) {
        dispatch(databasesAC.submitBulkEditRequestOK())
        if(data.bulkEditConfiguration.requests.length > 0) {
          dispatch(customMessageRequest('success', 'Operation was enqueued.'))
        }
        else if (configurationOption?.value === CONFIG_OPTION_DATABASE_ENABLED
          && data.bulkEditConfiguration.requests.length === 0 && databaseIds.length) {
          await router.stateService.reload()
          dispatch(customMessageRequest('success', 'Operation completed successfully.'))
        }
        else if (data.bulkEditConfiguration.requests.length === 0) {
          let errorMessage = 'No jobs were created for invalid DB(s).'
          if(urlOption?.value === UrlSelection.ALL) {
            errorMessage = 'At least one valid url is required to create a job request.'
          }
          dispatch(customMessageRequest('critical', errorMessage))
          dispatch(databasesAC.submitBulkEditRequestERR())
        }
      } else {
        dispatch(genericRequestError())
        dispatch(databasesAC.submitBulkEditRequestERR())
      }
    }
  } catch(err) {
    dispatch(genericRequestError())
    dispatch(databasesAC.submitBulkEditRequestERR())
  }
}

export const deleteCustomConfigOverride = (databaseId: string, customConfigOverrideTag: string, jobType: string) => async function (dispatch) {
  const input: DeleteCustomConfigOverrideTagInput = {
    databaseId: databaseId,
    customConfigOverrideTag: customConfigOverrideTag,
  }

  const {data} = await deleteCustomConfigOverrideTag(input)

  if (data?.deleteCustomConfigOverrideTag?.isDeleted) {
    dispatch(databasesAC.deleteCustomConfigOverridesOK(jobType, customConfigOverrideTag))
  }
}

export const databasesAC = createActionCreators(Databases)

export default Databases
